<template>
	<div class="readtop_box" @click="showBottomBox = false">
		<div class="readpage_top" v-if="fileInfo">
			<div class="left">
				<img src="@comm/images/document-conversion/zxyl/ofd_icon.png" v-if="fileInfo.fileType == 'ofd'" alt=''/>
				<img
					src="@comm/images/document-conversion/zxyl/pdf_icon.png"
					v-else-if="fileInfo.fileType == 'pdf'" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/word_icon.png"
					v-else-if="['doc', 'docx'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/excel_icon.png"
					v-else-if="['xls', 'xlsx'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/tiff_icon.png"
					v-else-if="['tiff', 'tif'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/ppt_icon.png"
					v-else-if="['ppt', 'pptx'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/wps_icon.png"
					v-else-if="['wps'].includes(fileInfo.fileType)" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/txt1_icon.png"
					v-else-if="fileInfo.fileType == 'txt'" alt=''
				/>
				<img
					src="@comm/images/document-conversion/zxyl/img_icon.png"
					v-else-if="['jpg', 'png', 'bmp'].includes(fileInfo.fileType)" alt=''
				/>
				<img src="@comm/images/document-conversion/zxyl/error_img.png" v-else alt=''/>
				<a v-if="fileInfo&&isPhone === 'true'" :title="fileInfo.sName">{{ fileInfo.sName | limitFileName(10, true) }}</a>
				<a v-if="fileInfo&&isPhone === 'false'" :title="fileInfo.sName">{{ fileInfo.sName | limitFileName(20, true) }}</a>
			</div>
			<div class="right" v-if="isPhone === 'true'" @click.stop="showBottomBox = !showBottomBox">
				<span class="mobile_home"></span>
			</div>
			<div class="right" v-if="fileInfo && isPhone !== 'true'">
				<div
					class="item"
					:class="{ disable: status === 'shareReadPage' && (fileInfo.permissionDownload == 1 || fileInfo.expiredType == -1) }"
					@click="downBtn"
				>
					<span class="downbtn_icon"></span>
					下载
				</div>
				<div
					class="item"
					@click="goPrint"
					:class="{ disable: status === 'shareReadPage' && (fileInfo.permissionPrint == 1 || fileInfo.expiredType == -1) }"
				>
					<span class="dy_icon"></span>
					打印
				</div>
				<div
					class="item"
					@click="shareBtn"
					:class="{ disable: status === 'shareReadPage' && fileInfo.expiredType == -1 }"
				>
					<span class="share_icon"></span>
					分享
				</div>
				<div
					class="item"
					@click="handleCheck"
					:class="{ disable: status === 'shareReadPage' && fileInfo.expiredType == -1 }"
				>
					<span class="phone_icon"></span>
					手机查看
				</div>
				<div class="item" @click="moreBtn">
					<span class="more_icon"></span>
					更多
				</div>
			</div>
		</div>
		<div class="qrcode_box" v-if="showPhone">
			<div class="qrcode_body">
				<p class="name">手机扫描二维码预览文件</p>
				<div class="qrcode_main">
					<div id="qrcode" class="qrcode" ref="qrcode"></div>
					<div class="qrcode_cover"></div>
				</div>
				<a class="sname" :title="fileInfo.fileName">{{ fileInfo.fileName | limitFileName(10) }}</a>
				<p class="size">文档大小：{{ fileInfo.fileSize }}</p>
				<div class="closed_btn" @click="showPhone = false"></div>
			</div>
		</div>
		<div class="qrcode_box more_box" v-if="showMore">
			<div class="qrcode_body">
				<div class="list" @click="helpBtn">帮助</div>
				<div class="list" @click="feedBtn">意见反馈</div>
				<div class="list" @click="aboutBtn">关于</div>
			</div>
		</div>
		<share
			v-if="fileInfo"
			:showShare="showShare"
			:shareUrl="shareUrl"
			:fileInfo="fileInfo"
			@closeBtn="closeBtn"
			:status="status"
		></share>
		<feed-back :showFeedDialog="showFeedDialog" @closed="closedFeedDialog"></feed-back>
		<about-read :showReadDialog="showReadDialog" @closed="closedReadDialog"></about-read>
		<div class="bottom_box" v-if="showBottomBox">
			<ul>
				<li
					:class="{ disable: status === 'shareReadPage' && (fileInfo.permissionDownload == 1 || fileInfo.expiredType == -1) }"
					@click.stop="downBtn"
					v-if="fileInfo.fileType != 'ofd'"
				>
					<span class="xz"></span>下载
				</li>
				<li
					@click.stop="shareBtn"
					:class="{ disable: status === 'shareReadPage' && fileInfo.expiredType == -1 }"
				>
					<span class="fx"></span>分享
				</li>
				<li @click.stop="helpBtn">
					<span class="bz"></span>帮助
				</li>
				<li @click.stop="feedBtn">
					<span class="yjfk"></span>意见反馈
				</li>
				<li @click.stop="aboutBtn">
					<span class="gy"></span>关于
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import QRCode from "qrcodejs2";
import { saveAs } from "file-saver";
import common from "@comm/utils/common";
import { getToken,getUserInfo } from "@comm/utils/auth";
import { downloadqyd,eventCount } from "@comm/api/document-conversion";
import share from "@comm/components/document-conversion/shareBox";
import feedBack from "@comm/components/document-conversion/feedback";
import aboutRead from "@comm/components/document-conversion/aboutRead";
export default {
	components: { share, feedBack, aboutRead },
	props: {
		fileInfo: {
			type: Object,
			required: true
		},
		status: String
	},
	data() {
		return {
			showPhone: false,
			showMore: false,
			shareUrl: "",
			showShare: false,
			showFeedDialog: false,
			showReadDialog: false,
			isPhone: null,
			showBottomBox: false,
		};
	},
	created() {
		this.isPhone = localStorage.getItem("isPhone");
		this.userInfo = getUserInfo()?JSON.parse(getUserInfo()):null
	},
	methods: {
		// 下载
		downBtn() {
			if (this.status === 'shareReadPage' && (this.fileInfo.permissionDownload == 1 || this.fileInfo.expiredType == -1)) return
			this.showBottomBox=false
			downloadqyd(this.fileInfo.fileId).then(res => {
				if (!res) {
					Message.error("下载文件失败");
					return false;
				}
				let filename = this.fileInfo.fileName;
				const blob = new Blob([res.data]);
				if (sessionStorage.getItem("browserType") == "IE") {
					saveAs(blob, filename);
				} else {
					const downloadElement = document.createElement("a");
					const href = window.URL.createObjectURL(blob);
					downloadElement.href = href;
					downloadElement.download = decodeURIComponent(filename);
					document.body.appendChild(downloadElement);
					downloadElement.click();
					document.body.removeChild(downloadElement);
					window.URL.revokeObjectURL(href);
				}
			})
				.catch((err) => {
					if (err.code == "ECONNABORTED" && err.message.indexOf("timeout") != -1) {
						this.$alert("网络不佳或内容过大", "提示", {
							confirmButtonText: "确定"
						});
					}
				});

		},
		// 去打印
		goPrint() {
			this.showPhone = false;
			this.showMore = false;
			if (this.status === 'shareReadPage' && (this.fileInfo.permissionPrint == 1 || this.fileInfo.expiredType == -1)) return;
			this.$emit('printBth')
		},
		// 分享
		shareBtn() {
			this.showPhone = false;
			this.showMore = false;
			this.showBottomBox=false
			if (this.status === 'shareReadPage' && this.fileInfo.expiredType == -1) return
			if(this.status === 'shareReadPage'){
				let nickname = encodeURIComponent(encodeURIComponent(localStorage.nickname))
				this.shareUrl = `${common.readCodeUrl}/s:${this.fileInfo.shareUrl}&&${nickname}`;
			}else{
			this.userInfo = getUserInfo()?JSON.parse(getUserInfo()):null
			let nickname = encodeURIComponent(encodeURIComponent(this.userInfo.nickname))
			this.shareUrl = `${common.readCodeUrl}/s:${this.fileInfo.shareUrl}&&${nickname}`;
			}
			this.showShare = true;
			eventCount({
				eventId: 1001,
				userId: this.userInfo.suwellUserId,
				fileId: this.fileInfo.fileId
			}).then((res) => {

			})

		},
		makeQrcode(text) {
			new QRCode("qrcode", {
				width: 142, // 设置宽度，单位像素
				height: 142, // 设置高度，单位像素
				correctLevel: 3,
				text // 设置二维码内容或跳转地址
			});
		},
		//打开查看
		handleCheck(val) {
			this.showMore = false;
			this.userInfo = getUserInfo()?JSON.parse(getUserInfo()):null
			if (this.status === 'shareReadPage' && this.fileInfo.expiredType == -1) return
			this.showPhone = !this.showPhone;
			if (this.showPhone) {
				let url = ''
				let nickname = encodeURIComponent(encodeURIComponent(localStorage.nickname))
				if (this.status == 'readPage') {
					url = `${common.readCodeUrl}/r:${this.fileInfo.shareUrl}&&${nickname}`
				} else {
					if(this.status === 'shareReadPage'){
				url = `${common.readCodeUrl}/s:${this.fileInfo.shareUrl}&&${nickname}`;
			}
				}
				this.$nextTick(() => {
					this.makeQrcode(url);
				});
			}
		},
		// 查看更多
		moreBtn() {
			this.showPhone = false;
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
		},
		closeBtn() {
			this.showShare = false;
		},
		// 帮助
		helpBtn() {
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
			this.showBottomBox=false
			window.open("http://suwell.cn/", "_blank");
		},
		// 关于
		aboutBtn() {
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
this.showBottomBox=false
			this.showReadDialog = true;
		},
		// 意见反馈
		feedBtn() {
			if (this.isPhone !== 'true') {
				this.showMore = !this.showMore;
			}
			this.showBottomBox=false
			this.showFeedDialog = true;
		},
		closedFeedDialog(data) {
			this.showFeedDialog = data;
		},
		closedReadDialog(data) {
			this.showReadDialog = data;
		}
	}
};
</script>

<style lang="scss" scoped>
.bottom_box {
	width: 100%;
	height: 100%;
	background-color: rgba(0,0,0,.6);
	position: fixed;
	bottom: 0;
	left: 0;
	z-index: 999;
	ul{
		background-color: #fff;
		position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	padding: 20px 0;
	border-radius: 10px 10px 0 0;
	}
	li {
		margin-top: 10px;
		padding: 10px 20px 10px 30px;
		line-height: 18px;
		font-size: 14px;
		background-color: #fff;
		&.disable{
			opacity: 0.5;
		}
		&:active,&:focus{
			background-color: #efefef;
		}
		span {
			display: inline-block;
			width: 20px;
			height: 20px;
			margin-right: 20px;
			vertical-align: middle;
			&.xz {
			background: url("../../../images/document-conversion/down_icon.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.fx {
			background: url("../../../images/document-conversion/mobileIcon/icon_02.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.bz {
			background: url("../../../images/document-conversion/mobileIcon/icon_03.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.yjfk {
			background: url("../../../images/document-conversion/mobileIcon/icon_04.svg")
				0 0 no-repeat;
			background-size: 100%;
		}
		&.gy {
				background: url("../../../images/document-conversion/mobileIcon/icon_05.svg")
					0 0 no-repeat;
				background-size: 100%;
			}
		}

		&:nth-child(5) {
			padding-bottom: 20px;
		}
	}
}
.readtop_box {
    position: relative;
	height: 44px;
	.readpage_top {
		height: 100%;
		background: #f5f5f5;
		padding: 0 15px 0 10px;
		border-bottom: 1px solid #eaeaea;
		.left {
			height: 44px;
			font-size: 14px;
			color: #000000;
			float: left;
			display: flex;
			align-items: center;
			img {
				display: inline-block;
				width: 32px;
				height: 32px;
				margin-right: 6px;
				vertical-align: middle;
			}
		}
		.right {
			float: right;
			height: 44px;
			font-size: 12px;
			color: #333333;
			display: flex;
			align-items: center;
			.mobile_home {
				width: 20px;
				height: 20px;
				background: url("../../../images/document-conversion/mobileIcon/home.svg")
					0 0 no-repeat;
				background-size: 100%;
				display: block;
			}
			.item {
				margin-left: 15px;
				width: auto;
				padding: 5px;
				&:hover {
					cursor: pointer;
					background: #e4e4e4;
					border-radius: 2px;
				}
				&.disable,
				&.disable:hover {
					opacity: 0.5;
					cursor: default;
				}
			}
			span {
				display: inline-block;
				width: 24px;
				height: 24px;
				margin-right: 5px;
				vertical-align: middle;
				&.downbtn_icon {
					background: url("../../../../comm/images/document-conversion/zxyl/down_btn.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.dy_icon {
					background: url("../../../../comm/images/document-conversion/zxyl/dy_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.share_icon {
					background: url("../../../../comm/images/document-conversion/zxyl/share_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.phone_icon {
					background: url("../../../../comm/images/document-conversion/zxyl/phone_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
				&.more_icon {
					background: url("../../../../comm/images/document-conversion/zxyl/more_icon.png")
						0 0 no-repeat;
					background-size: 100%;
				}
			}
		}
	}
	.qrcode_box {
		width: 198px;
		height: 246px;
		background: #ffffff;
		box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2);
		position: fixed;
		top: 44px;
		right: 32px;
		z-index: 999;
		&.more_box {
            position: absolute;
			width: 139px;
			height: 82px;
			border-radius: 2px;
			border: 1px solid #cccccc;
			right: 15px;
			.qrcode_body {
				padding: 5px 0;
				align-items: flex-start;
				.list {
					height: 24px;
					padding: 0 23px;
					line-height: 24px;
					font-size: 12px;
					color: #333333;
					width: 100%;
					cursor: pointer;
					&:hover {
						background: #f5f5f5;
					}
				}
			}
		}
		.qrcode_body {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: center;
			.qrcode_main {
				width: 150px;
				height: 150px;
				border: 1px solid #e7e7e7;
				margin: 4px 0;
				position: relative;
				.qrcode {
					margin: 4px auto;
					width: 142px;
					height: 142px;
				}
				.qrcode_cover {
					width: 142px;
					height: 142px;
					position: absolute;
					top: 4px;
					left: 4px;
					background: transparent;
				}
			}
			.closed_btn {
				position: absolute;
				top: 15px;
				right: 15px;
				width: 17px;
				height: 16px;
				background: url("../../../../comm/images/document-conversion/zxyl/close_btn.png")
					0 0 no-repeat;
				background-size: 100%;
			}
			.name {
				font-size: 12px;
				color: #333333;
				line-height: 16px;
				margin-top: 28px;
			}
			.sname {
				font-size: 12px;
				color: #008ad9;
				line-height: 18px;
				text-decoration: none;
			}
			.size {
				font-size: 12px;
				color: #b1b1b1;
				line-height: 18px;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/comm/components/document-conversion/readpageTop/index.vue